// unsafeGet :: forall r a. String -> Record r -> a
exports.unsafeGet = function(label) {
  return function(record) {
    return record[label];
  };
};
